import cn from "app/utils/classnames";

interface MisspellingProps {
  children: React.ReactNode;
  className?: string;
}

// Highlights child text with a wavy colored underline
export default function Misspelling(props: MisspellingProps) {
  return (
    <span
      className={cn(
        "underline decoration-red-400 decoration-[1.3px] decoration-wavy underline-offset-[10%]",
        props.className
      )}
    >
      {props.children}
    </span>
  );
}
